export default function () {
  return [
    {
      type: 'Input',
      title: '员工工号',
      [$field]: 'userCode',
      rules: ['']
    },
    {
      type: 'Input',
      title: '姓名',
      [$field]: 'userName',
      rules: ['']
    },
    // {
    //   type: 'photo',
    //   title: '照片',
    //   [$field]: 'photo',
    //   photoDisabled: true,
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM14',
    //       merge: false
    //     }
    //   },
    //   optionList: [],
    //   title: '性别',
    //   [$field]: 'gender',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '国籍',
    //   [$field]: 'nationality',
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '民族',
    //   [$field]: 'nation',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM15',
    //       merge: false
    //     }
    //   }
    // },
    // {
    //   type: 'DatePicker',
    //   title: '出生日期',
    //   [$field]: 'birthday',
    //   rules: ['']
    // },
    // {
    //   type: 'InputNumber',
    //   title: '年龄',
    //   min: 0,
    //   [$field]: 'userAge',
    //   rules: [
    //     {
    //       validator (rule, value, resolve, reject) {
    //         if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
    //         resolve()
    //       },
    //       trigger: 'change'
    //     }
    //   ]
    // },
    // {
    //   type: 'SelectTree',
    //   title: '籍贯',
    //   [$field]: 'nativePlace',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'ZB01',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // },
    // {
    //   title: '户口类型',
    //   [$field]: 'expandFieldbb',
    //   rules: ['']
    // },
    // {
    //   title: '户口所在地',
    //   type: 'SelectTree',
    //   [$field]: 'domicile',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'ZB01',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '婚姻状况',
    //   [$field]: 'maritalState',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'GB22612',
    //       merge: false
    //     }
    //   }
    // },
    // {
    //   type: 'Select',
    //   optionList: [
    //     {
    //       label: '身份证18位',
    //       value: '1'
    //     }
    //   ],
    //   title: '证件类型',
    //   [$field]: 'idType',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '身份证件号码',
    //   [$field]: 'idCardNum'
    // },
    // {
    //   type: 'DatePicker',
    //   title: '证件有效期自',
    //   [$field]: 'expandFieldb',
    //   rules: ['']
    // },
    // {
    //   type: 'DatePicker',
    //   title: '证件有效期至',
    //   [$field]: 'expandFieldc',
    //   rules: ['']
    // },
    // {
    //   type: 'SelectTree',
    //   title: '最高学历',
    //   [$field]: 'education',
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM16',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM17',
    //       merge: false
    //     }
    //   },
    //   title: '最高学位',
    //   [$field]: 'degree',
    //   optionList: [],
    //   rules: []
    // },
    // {
    //   title: '教育形式',
    //   [$field]: 'expandFieldaa',
    //   rules: ['']
    // },
    // {
    //   title: '毕业学校',
    //   [$field]: 'expandFieldab',
    //   rules: ['']
    // },
    // {
    //   type: 'DatePicker',
    //   title: '毕业时间',
    //   [$field]: 'expandFieldac',
    //   rules: ['']
    // },
    // {
    //   title: '是否有海外留学背景',
    //   [$field]: 'expandFieldad',
    //   type: 'RemoteSelect',
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ41',
    //       merge: false
    //     }
    //   },
    //   rules: ['']
    // },
    // {
    //   type: 'RemoteSelect',
    //   title: '政治面貌',
    //   [$field]: 'polity',
    //   rules: [''],
    //   props: {
    //     url: 'module/dict/outGetList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'GB4762',
    //       merge: false
    //     }
    //   }
    // },
    {
      type: 'RemoteSelect',
      title: '政治面貌',
      [$field]: 'polity',
      rules: [''],
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'GB4762',
          bizLineCode: 'YWX01',
          merge: false
        }
      }
    },
    // {
    //   type: 'Input',
    //   title: '籍贯',
    //   readOnly: true,
    //   [$field]: 'expandFielda',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '手机号码',
    //   [$field]: 'phone'
    // },
    // {
    //   type: 'Input',
    //   title: '家庭住址',
    //   [$field]: 'familyAddr',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '现居住地',
    //   [$field]: 'nowLocation',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '固定电话',
    //   [$field]: 'telphone',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '工号',
    //   [$field]: 'userCode',
    //   rules: ['']
    // },
    // {
    //   type: 'Input',
    //   title: '所在单位',
    //   [$field]: 'depName',
    //   rules: ['']
    // },
    // {
    //   title: 'BG/体系',
    //   [$field]: 'expandFieldae',
    //   rules: ['']
    // },
    // {
    //   title: '平台',
    //   [$field]: 'expandFieldaf',
    //   rules: ['']
    // },
    // {
    //   title: '组织',
    //   [$field]: 'expandFieldag',
    //   rules: ['']
    // },
    // {
    //   title: '中心',
    //   [$field]: 'expandFieldah',
    //   rules: ['']
    // },
    // {
    //   title: '副中心',
    //   [$field]: 'expandFieldai',
    //   rules: ['']
    // },
    // {
    //   title: '本部',
    //   [$field]: 'expandFieldaj',
    //   rules: ['']
    // },
    // {
    //   title: '副本部',
    //   [$field]: 'expandFieldak',
    //   rules: ['']
    // },
    // {
    //   title: '部门',
    //   [$field]: 'expandFieldal',
    //   rules: ['']
    // },
    // {
    //   title: '科室',
    //   [$field]: 'expandFieldam',
    //   rules: ['']
    // },
    // {
    //   title: '所属组织层级',
    //   [$field]: 'allName',
    //   rules: ['']
    // },
    // {
    //   type: 'SelectTree',
    //   title: '标准岗位',
    //   [$field]: 'workPost',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'DM18',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // },
    // {
    //   title: '岗位信息详情',
    //   [$field]: 'expandFieldao',
    //   rules: ['']
    // },
    // {
    //   type: 'SelectTree',
    //   title: '管理职务',
    //   [$field]: 'hrDuty',
    //   rules: [''],
    //   props: {
    //     treeType: 'tireTree',
    //     url: 'api-general/module/portal/user/outGetRadioList',
    //     map: {
    //       title: 'title',
    //       value: 'value'
    //     },
    //     params: {
    //       dictCode: 'KZ27',
    //       merge: false,
    //       bizLineCode: 'YWX01'
    //     }
    //   }
    // },
    // {
    //   title: 'Band职级',
    //   [$field]: 'expandFieldm'
    // },
    // {
    //   type: 'DatePicker',
    //   title: '本岗位任职时间(月)',
    //   [$field]: 'jobTime',
    //   rules: ['']
    // },
    // {
    //   title: '员工类别',
    //   [$field]: 'expandFieldr'
    // },
    // {
    //   title: '社保缴纳地',
    //   [$field]: 'expandFieldas'
    // },
    // {
    //   title: '公积金缴纳地',
    //   [$field]: 'expandFieldat'
    // },
    // {
    //   title: '招聘渠道',
    //   [$field]: 'expandFieldau'
    // },
    {
      type: 'DatePicker',
      title: '入BOE日期',
      [$field]: 'work4BOE'
    },
    // {
    //   type: 'InputNumber',
    //   title: '司龄',
    //   min: 0,
    //   [$field]: 'expandFieldj',
    //   rules: [
    //     {
    //       validator (rule, value, resolve, reject) {
    //         if (value != null && !/^[1-9]\d*$/.test(value)) return resolve(new Error('只能输入正整数'))
    //         resolve()
    //       },
    //       trigger: 'change'
    //     }
    //   ]
    // },
    // {
    //   type: 'DatePicker',
    //   title: '入司时间',
    //   [$field]: 'inDeptDate',
    //   rules: ['']
    // },
    {
      type: 'DatePicker',
      title: '开始工作日期',
      [$field]: 'time2Work',
      rules: ['']
    },
    // {
    //   title: '发薪地',
    //   [$field]: 'expandFieldl'
    // },
    // {
    //   title: '工作地',
    //   [$field]: 'expandFieldax'
    // },
    // {
    //   title: '公司邮箱',
    //   [$field]: 'expandFielday'
    // },
    // {
    //   title: '工资',
    //   [$field]: 'expandFieldk'
    // },
    {
      title: '所属法人体',
      [$field]: 'bPayPlcDescr'
    }
    // ,
    // {
    //   title: '就业状态',
    //   [$field]: 'expandFieldn'
    // }
  ]
}